// Route search params, kept apart from the page (2026-10-31): the route file's validateSearch is not code-split, so
// whatever it imports ships in the first-load entry chunk. This file must stay free of React, UI and messages.
import { PRESETS } from "../reports/presets";

export const RANGES = PRESETS;
export type DashboardSearch = { range?: (typeof RANGES)[number] };
